import { camelToKebabCase, camelToSnakeCase } from '@utils/utilities'
import isEmpty from 'lodash/isEmpty'

interface IBriefFormWasUpdated {
  briefingFormOutput: Record<string, string | string[]>
}

const briefingFormWasUpdated = ({
  briefingFormOutput,
}: IBriefFormWasUpdated): boolean => {
  const selectedValues = Object.values(briefingFormOutput || {})
  const selectionContainsValidValues = selectedValues?.some(
    (value) => !isEmpty(value)
  )
  return selectionContainsValidValues
}

const EMPTY_STATE_BRIEF_STEP_KEY = 'key-is-not-defined'

const optionKeyToKebabCase = (key: string) => {
  const formattedKey = camelToKebabCase(key?.trim())

  return formattedKey.replaceAll(' ', '-') || EMPTY_STATE_BRIEF_STEP_KEY
}

const briefStepLabelToKey = (label: string) => {
  // Removing all non letter symbols, like "&"" and "?"
  const formattedLabel = label.replace(/[^a-zA-Z]+/g, ' ')
  return optionKeyToKebabCase(formattedLabel)
}

export { briefingFormWasUpdated, optionKeyToKebabCase, briefStepLabelToKey }
